import React, { useRef, useEffect, useState } from 'react';
import { animate } from 'animejs';
import { useLanguage } from '../context/LanguageContext';
import './Testimonials.css';

function Testimonials() {
  const { t } = useLanguage();
  const sectionRef = useRef(null);
  const [current, setCurrent] = useState(0);
  const items = t('testimonials.items');

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        const card = section.querySelector('.testimonial-card');
        if (card) animate(card, { opacity: [0, 1], y: [24, 0], duration: 600, ease: 'outExpo' });
        observer.disconnect();
      },
      { rootMargin: '0px 0px -60px 0px', threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const id = setInterval(() => {
      setCurrent((c) => (c + 1) % items.length);
    }, 5000);
    return () => clearInterval(id);
  }, [items.length]);

  return (
    <div ref={sectionRef} className="testimonials">
      <h2 id="testimonios-title" className="section-title">{t('testimonials.title')}</h2>
      <div className="testimonials-slider">
        <div className="testimonial-card">
          <blockquote className="testimonial-quote">
            "{items[current].text}"
          </blockquote>
          <footer className="testimonial-author">
            <strong>{items[current].name}</strong>
            <span>{items[current].role}</span>
          </footer>
        </div>
        <div className="testimonials-dots" aria-hidden="true">
          {items.map((_, i) => (
            <button
              key={i}
              type="button"
              className={`testimonial-dot ${i === current ? 'is-active' : ''}`}
              onClick={() => setCurrent(i)}
              aria-label={`Ver testimonio ${i + 1}`}
              aria-current={i === current ? 'true' : undefined}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Testimonials;
